import validator from 'validator';

const slideUp = (target, duration = 500) => {
  target.style.transitionProperty = 'height, margin, padding';
  target.style.transitionDuration = `${duration}ms`;
  target.style.height = `${target.offsetHeight}px`;
  target.style.overflow = 'hidden';
  target.style.height = 0;
  target.style.paddingTop = 0;
  target.style.paddingBottom = 0;
  target.style.marginTop = 0;
  target.style.marginBottom = 0;
  window.setTimeout(() => {
    target.style.display = 'none';
    target.style.removeProperty('height');
    target.style.removeProperty('padding-top');
    target.style.removeProperty('padding-bottom');
    target.style.removeProperty('margin-top');
    target.style.removeProperty('margin-bottom');
    target.style.removeProperty('overflow');
    target.style.removeProperty('transition-duration');
    target.style.removeProperty('transition-property');
  }, duration);
};

/**
 * Создает экземпляр Field.
 *
 * @constructor
 * @this  {Field}
 * @param {field} r - HTML элемент input.
 */
class Field {
  constructor(field) {
    this.field = field;
    this.errorClass = '_error';

    this.init();
  }

  /** @private */
  init() {
    this.addEventListeners();
  }

  /** @private */
  addEventListeners() {
    this.field.addEventListener('focus', () => {
      this.removeError();
    });
    this.field.addEventListener('change', () => {
      this.removeError();
    });
  }

  addError() {
    if (!this.field.value && this.field.getAttribute('data-required') !== 'lk-tel') {
      const parentElem = this.field.closest('.profile-input');
      if (parentElem) {
        const errorElem = parentElem.querySelector('.form__input-error');
        errorElem.innerHTML = 'Поле не заполнено';
      }
    }
    this.field.classList.add(this.errorClass);
  }

  removeError() {
    this.field.classList.remove(this.errorClass);

    const form = this.field.closest('.js-form');
    if (form) {
      const errorBlock = form.querySelector('.error_request');
      if (errorBlock) slideUp(errorBlock);
    }
  }

  validation() {
    switch (this.field.getAttribute('data-required')) {
      case 'text':
        if (this.field.value) {
          this.removeError();
          return true;
        }
        break;
      case 'select':
        if (this.field.value) {
          this.removeError();
          return true;
        }
        break;
      case 'checkbox':
        if (this.field.checked) {
          this.removeError();
          return true;
        }
        break;
      case 'tel':
        if (this.field.value !== '' && this.field.value.indexOf('_') === -1) {
          this.removeError();
          return true;
        }
        break;
      case 'lk-tel':
        // eslint-disable-next-line
        const regExp = /^\+7\s\(\d{3}\)\s\d{3}-\d{2}-\d{2}$/;
        if (this.field.value.length === 0 || regExp.test(this.field.value)) {
          this.removeError();
          return true;
        }
        break;
      case 'email':
        if (validator.isEmail(this.field.value)) {
          this.removeError();
          return true;
        }
        break;
      case 'file':
        if (this.field.value) {
          this.removeError();
          return true;
        }
        break;
      default:
        return true;
    }
    this.addError();
    return false;
  }
}

export default Field;
